/**
 * The drawn A (Matthew, 1 November 2026), the same opening as the iPhone
 * app's (accra-app IntroAnimationView.swift) so the two always match: the
 * Addaiaspora mark is drawn from the inside tip of the arc, clockwise round
 * the letter, and the star pops in last. A wide stroke along the mark's
 * centre line reveals the real artwork; nothing is redrawn.
 */

/** The centre line, in the artwork's own pixels (534 x 460). */
export const INTRO_PATH =
  'M93 342 C150 290 230 255 330 250 C400 247 440 262 458 290 L505 405 Q515 432 488 432 ' +
  'L372 432 L352 398 L345 330 L318 368 L292 370 L271 344 L271 297 L271 344 L248 370 L220 368 ' +
  'L196 330 L190 395 L172 432 L40 432 Q14 432 26 405 L190 40 Q198 22 220 22 L315 22 Q336 22 345 42 L442 232';

/** How long the intro runs before the dashboard may replace it. */
export const INTRO_MS = 2450;
export const INTRO_REDUCED_MS = 600;

const MARK = '/brand/addaiaspora-icon-white.png';

export function Intro({ note }: { note?: string }) {
  return (
    <div className="intro" role="img" aria-label="A.C.C.R.A">
      <svg className="intro-mark" viewBox="0 0 534 460" aria-hidden>
        <defs>
          <mask id="intro-reveal" maskUnits="userSpaceOnUse" x="0" y="0" width="534" height="460">
            <path
              className="intro-stroke"
              d={INTRO_PATH}
              pathLength={1}
              fill="none"
              stroke="#fff"
              strokeWidth={52}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </mask>
          <clipPath id="intro-star">
            <rect x="200" y="85" width="135" height="125" />
          </clipPath>
        </defs>
        <image href={MARK} width="534" height="460" mask="url(#intro-reveal)" />
        <g className="intro-star" clipPath="url(#intro-star)">
          <image href={MARK} width="534" height="460" />
        </g>
      </svg>
      {note && <p className="intro-note">{note}</p>}
    </div>
  );
}
